module.exports = __webpack_public_path__ + "media/images/photos/6-5099949a87f354f4240deed590717e60.jpg";